
import React from 'react';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { Field, change } from 'redux-form';

import { InputWithErrors } from '../../lib/forms';
import { isRequired } from '../../lib/forms/Validations';

let AddressForm = ({ className, changeFieldValue, translate, addressComponents }) => {
  let StreetNumber = '';
  let StreetName = '';
  let city = '';
  let country = '';

  if (addressComponents) {
    addressComponents.map(({ long_name, short_name, types }) => {
      if (types[0] === 'street_number') {
        StreetNumber = long_name
        changeFieldValue('house_number', long_name);
      } else if (types[0] === 'route') {
        StreetName = long_name;
        changeFieldValue('address', long_name);
      } else if (types[0] === 'locality') {
        city = long_name;
        changeFieldValue('city', long_name);
      } else if (types[0] === 'country') {
        country = long_name;
        changeFieldValue('country', long_name);
      }
    });
  }
  return (
    <div id="address" className={className}>
      <div className="form-group row">
        <div className="col-md-6 col-lg-6">
          <label>{translate('street-name')}</label>
          <Field name="address" placeholder={translate("street-name")} component={InputWithErrors} translate={translate} className="form-control" initvalue={StreetName} type="text" />
        </div>
        <div className="col-md-6 col-lg-6">
          <label>{translate('house-number')}</label>
          <Field name="house_number" placeholder={translate("house-number")} component={InputWithErrors} translate={translate} className="form-control" type="text" initvalue={StreetNumber} validate={[isRequired]} />
        </div>
        <div className="col-md-6 col-lg-6">
          <label>{translate('apartment-number')}</label>
          <Field name="apartment_number" placeholder={translate("apartment-number")} component={InputWithErrors} translate={translate} className="form-control" type="number" />
        </div>
        <div className="col-md-6 col-lg-6">
          <label>{translate('entrance')}</label>
          <Field name="entrance" placeholder={translate("entrance")} component={InputWithErrors} translate={translate} className="form-control" type="text" />
        </div>
        <div className="col-md-6 col-lg-4">
          <label>{translate('city')}</label>
          <Field name="city" placeholder={translate("city")} component={InputWithErrors} translate={translate} className="form-control" type="text" initvalue={city} validate={[isRequired]} />
        </div>
        <div className="col-md-6 col-lg-4">
          <label>{translate('country')}</label>
          <Field name="country" placeholder={translate("country")} component={InputWithErrors} translate={translate} className="form-control" type="text" initvalue={country} validate={[isRequired]} />
        </div>
        <div className="col-md-6 col-lg-4">
          <label>{translate('postcode')}</label>
          <Field name="postcode" placeholder={translate("postcode")} component={InputWithErrors} translate={translate} className="form-control" type="text" />
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = state => ({
  translate: getTranslate(state.locale),
  currentLanguage: getActiveLanguage(state.locale).code,
});

const mapDispatchToProps = dispatch => ({
  changeFieldValue: (field, value) => {
    dispatch(change('EditAddress', field, value));
  },
});

AddressForm = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddressForm);
// AddressFormHandler = withRouter(AddressFormHandler);
export default AddressForm;



// WEBPACK FOOTER //
// ./src/components/Address/AddressForm.js